module.exports = __webpack_public_path__ + "img/ysgj_033@2x.59b286fb.png";